/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';

import { useMutation } from '@tanstack/react-query';
import { getDocumentsWeb } from '@/services/getDocumentsWeb';
import DocumentsWebTable from './DocumentsWebTable';
import { TableFilters } from './TableFiltersType';
import { TransactionDetail } from './DocumentsType';

const today = new Date();
const oneDayAgo = new Date(today);
oneDayAgo.setDate(today.getDate() - 1);

const initialFilters: TableFilters = {
  fechaDesde: oneDayAgo,
  fechaHasta: today,
};

const DocumentsWeb = () => {
  const [filters, setFilters] = useState(initialFilters);
  const [parsedData, setParsedData] = useState<TransactionDetail[]>([]);

  const {
    data: documents,
    mutate,
    isPending,
  } = useMutation({
    mutationKey: ['DocumentsWeb'],
    mutationFn: () => getDocumentsWeb(filters),
  });

  useEffect(() => {
    if (documents) {
      const newData = documents.map((item: any) => {
        const { fechaDocumento, vencimiento, ...rest } = item;

        const fechaDocumentoParce = new Date(item?.fechaDocumento);
        const vencimientoParce = new Date(item?.vencimiento);

        return {
          ...rest,
          fechaDocumento: fechaDocumentoParce,
          vencimiento: vencimientoParce,
        };
      });
      setParsedData(newData);
    }
  }, [documents]);

  useEffect(() => {
    mutate();
  }, [mutate]);

  return (
    <DocumentsWebTable
      filters={filters}
      data={parsedData || []}
      setFilters={setFilters}
      onSearch={mutate}
      isLoading={isPending}
    />
  );
};

export default DocumentsWeb;
